const checkedColorStyles = {
  borderWidth: '2px',
  borderColor: 'product.secondary',
  backgroundColor: 'product.secondary',
  _hover: {
    borderColor: 'product.secondary',
    backgroundColor: 'product.secondary',
  },
}

const disabledColorStyles = {
  color: 'product.gray.500',
  backgroundColor: 'product.gray.50',
  borderColor: 'product.gray.50',
}

const indeterminateColorStyles = {
  color: 'white',
  backgroundColor: 'product.border.solid',
  borderColor: 'product.border.solid',
}

export const Checkbox = {
  baseStyle: {
    icon: {
      width: '9px',
      height: '9px',
    },
    control: {
      borderColor: 'product.border.solid',
      borderWidth: '1px',
      borderRadius: '1px',
      _indeterminate: checkedColorStyles,
      _checked: checkedColorStyles,
      _disabled: {
        ...disabledColorStyles,
        _checked: disabledColorStyles,
        _indeterminate: {
          ...indeterminateColorStyles,
          _hover: indeterminateColorStyles,
        },
        _hover: disabledColorStyles,
      },
    },
    label: { color: 'product.text.dark.bodySolid' },
  },
  sizes: {
    md: {
      label: { fontSize: 'sm' },
    },
    lg: {
      label: { fontSize: 'md' },
    },
  },
  variants: {
    badge: {
      control: {
        position: 'relative',
        top: -1,
        borderColor: 'gray.450',
        backgroundColor: 'gray.450',
        borderRadius: 'full',
        _checked: {
          borderColor: 'green.550',
          backgroundColor: 'green.550',
          _hover: {
            borderColor: 'green.550',
            backgroundColor: 'green.550',
          },
        },
        '&:not([data-checked])': {
          _after: {
            content: "''",
            width: 2,
            height: 0.5,
            backgroundColor: 'white',
          },
          '& svg': {
            display: 'none',
          },
        },
      },
      icon: {
        fontSize: 8,
      },
    },
    suggestion: {
      control: {
        borderColor: 'gray.50',
      },
    },
    metabase: {
      control: {
        borderColor: '#B8BBC3',
        border: '2px',
        borderRadius: '4px',
        _checked: {
          backgroundColor: 'metabaseTeal.500',
          borderColor: 'metabaseTeal.500',
          _hover: {
            backgroundColor: 'metabaseTeal.500',
            borderColor: 'metabaseTeal.500',
          },
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    },
  },
}
